module.exports = __webpack_public_path__ + "static/img/20040B_7_8_C_20230526_fit.9e0d678.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20040B_7_8_C_20230526_fit.png
// module id = OMhz
// module chunks = 0